export const charttypefullData = [
    { name: "Histogramme empilé", id: "columnstacked" },
    { name: "Histogramme", id: "column" },
    { name: "Courbe", id: "line" },
    { name: "Aire", id: "area" },
    { name: "Tableau", id: "tab" },
    // { name: "Palmarès", id: "palmares" },
    { name: "Camembert", id: "pie" },
    { name: "Histogramme", id: "columnchart" },
    { name: "Courbe", id: "linechart" },
    { name: "Aire", id: "areachart" },
    // { name: "Palmarès", id: "palmares" },
    { name: "Camembert", id: "piechart" },
    { name: "Multi axes", id: "dualaxis" },
    { name: "DPE", id: "dpe" },
    { name: "Bulles", id: "bubble" },
    { name: "Heatmap", id: "heatmap" },
    { name: "Tapis de points", id: "scatter" },
    { name: "Jauge", id: "gauge" },
    { name: "Multiple", id: "multiTime" },
]

export const charttypeselectData = [
    { name: "Tous les types", id: "all"},
    { name: "Histogramme", id: "column" },
    { name: "Courbe", id: "line" },
    { name: "Aire", id: "area" },
    { name: "Tableau", id: "tab" },
    { name: "Palmarès", id: "palmares" },
    { name: "Camembert", id: "pie" },
    { name: "Multi axes", id: "dualaxis" },
    { name: "DPE", id: "dpe" },
    { name: "Bulles", id: "bubble" },
    { name: "Heatmap", id: "heatmap" },
    { name: "Tapis de points", id: "scatter" },
    { name: "Jauge", id: "gauge" },
    { name: "Multiple", id: "multiTime" },
]

export const chartgranularityData = [
    { name: "Horaire", id: "hour" },
    { name: "Journalière", id: "day" },
    { name: "Hebdomadaire", id: "week" },
    { name: "Mensuelle", id: "month" },
    { name: "Annuelle", id: "year" },
]
export const chartgranularityfullData = [
    { name: "10 minutes", id: "10minutes" },
    { name: "Horaire", id: "hour" },
    { name: "Journalière", id: "day" },
    { name: "Hebdomadaire", id: "week" },
    { name: "Mensuelle", id: "month" },
    { name: "Annuelle", id: "year" },
]

export const chartsourceData = [
    { name: "Graphique existant", id: "existing" },
    { name: "Point de donnée", id: "point" },
    { name: "Type de donnée", id: "definition" },
]

export const chartgranularityselectData = [
    { name: "Toutes les granularités", id: "all"},
    { name: "10 minutes", id: "10minutes" },
    { name: "Horaire", id: "hour" },
    { name: "Journalière", id: "day" },
    { name: "Hebdomadaire", id: "week" },
    { name: "Mensuelle", id: "month" },
    { name: "Annuelle", id: "year" },
]